import { cn } from "@-/com.npmjs.cn";
import { WebsiteBrand } from "#website-brand";
import { WebsiteContainer } from "#website-container";
import { APP_STORE_URL, GOOGLE_PLAY_URL, LOG_IN_PATH } from "#website-store-links";
import { WebsiteText } from "#website-typography";

const WEBSITE_FOOTER_LINKS: { href: string; label: string; rel?: string }[] = [
  { href: APP_STORE_URL, label: "App Store" },
  { href: GOOGLE_PLAY_URL, label: "Google Play" },
  { href: "/support", label: "Support" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
  { href: LOG_IN_PATH, label: "Log in", rel: "nofollow" },
];

export function WebsiteFooter({ className }: { className?: string }) {
  return (
    <footer className={cn("bg-website-ink py-12 text-white", className)}>
      <WebsiteContainer className="flex flex-col gap-9 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <WebsiteBrand inverted />
          <WebsiteText className="mt-4" size="caption" tone="subtle">
            Chinese characters, one connection at a time.
          </WebsiteText>
        </div>
        <nav
          aria-label="Footer"
          className="flex flex-wrap gap-x-6 gap-y-3 text-[0.8rem] text-white/50"
        >
          {WEBSITE_FOOTER_LINKS.map((link) => (
            <a
              className="text-inherit no-underline transition-colors hover:text-white"
              href={link.href}
              key={link.label}
              rel={link.rel}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </WebsiteContainer>
    </footer>
  );
}
